import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import CompanyInfoContent from './AboutWindow/CompanyInfoContent';
import ProcessContent from './AboutWindow/ProcessContent';
import CostEstimatesContent from './AboutWindow/CostEstimatesContent';

const AboutWindow = ({ isAboutOpen, setIsAboutOpen, zFILO, addToZFILO, removeFromZFILO }) => {
    const zIndex = zFILO.indexOf('about') !== -1 ? 1000 + zFILO.indexOf('about') : 1000;
    const [activeFile, setActiveFile] = useState(null); // ← Track selected file

    const location = useLocation();
    const navigate = useNavigate();

    // Set the active file based on the current subroute
    useEffect(() => {
        if (location.pathname.startsWith('/about/company')) {
            setActiveFile('CompanyInfo.txt');
        } else if (location.pathname.startsWith('/about/process')) {
            setActiveFile('Process.txt');
        } else if (location.pathname.startsWith('/about/costs')) {
            setActiveFile('CostEstimates.txt');
        } else if (location.pathname === '/about') {
            setActiveFile(null);
        }
    }, [location.pathname]);

    const handleClose = () => {
        setIsAboutOpen(false);
        removeFromZFILO('about');
        navigate('/');
    };

    const handleMinimize = () => {
        setIsAboutOpen(false);
        removeFromZFILO('about');
        navigate('/');
    };

    const handleFileClick = (fileName) => {
        setActiveFile(fileName);
        if (fileName === 'CompanyInfo.txt') navigate('/about/company');
        else if (fileName === 'Process.txt') navigate('/about/process');
        else if (fileName === 'CostEstimates.txt') navigate('/about/costs');
    };

    if (!isAboutOpen) return null;

    return (
        <div className='AboutWindow DesktopWindow' style={{ zIndex }}>
            <div className='AboutWindowTitleBar DesktopWindowTitleBar'>
                <span className='Title'>About Us</span>
                <div className='ResizeButtons'>
                    <img src='/images/MinimizeIcon.png' alt='Minimize' className='MinimizeButton' onClick={handleMinimize} />
                    <img src='/images/MaximizeIcon.png' alt='Maximize' />
                    <img src='/images/SystemMessageCloseButton.png' alt='Close' className='CloseButton' onClick={handleClose} />
                </div>
            </div>
            {!activeFile && (<>
                <Helmet>
                    <title>About Us | We Are A Site</title>
                    <meta name="description" content="Learn about our mission, team, and how We Are A Site makes web development accessible for small business owners." />
                </Helmet>
                <div className='AboutContent'>
                    <div className='AboutTextFile' onClick={() => handleFileClick('CompanyInfo.txt')}>
                        <img src='/images/TextFileIcon.png' alt='Text File' className='AboutTextFileIcon' />
                        <span>CompanyInfo.txt</span>
                    </div>
                    <div className='AboutTextFile' onClick={() => handleFileClick('Process.txt')}>
                        <img src='/images/TextFileIcon.png' alt='Text File' className='AboutTextFileIcon' />
                        <span>Process.txt</span>
                    </div>
                    <div className='AboutTextFile' onClick={() => handleFileClick('CostEstimates.txt')}>
                        <img src='/images/TextFileIcon.png' alt='Text File' className='AboutTextFileIcon' />
                        <span>CostEstimates.txt</span>
                    </div>
                </div>
            </>)}

            {/* Render content conditionally */}
            {activeFile === 'CompanyInfo.txt' && <CompanyInfoContent setActiveFile={setActiveFile} />}
            {activeFile === 'Process.txt' && <ProcessContent setActiveFile={setActiveFile} />}
            {activeFile === 'CostEstimates.txt' && <CostEstimatesContent setActiveFile={setActiveFile} />}

        </div>
    );
};

export default AboutWindow;
